import { useTranslation } from "react-i18next";
import dayjs from "dayjs";
import { Box, IconButton, Stack } from "@mui/material";
import { RefreshOutlined } from "@mui/icons-material";
import { AppConstant, LangConstant } from "@/const";
import { RowUserType } from "@/types/view";
import { StatusUser } from "@/components/common";
import { GridColDef } from "@/components/common/AppTable/AppTable";

const useUserColumn = () => {
  const { t: getLabel } = useTranslation(LangConstant.NS_USER);

  const columnList: GridColDef<RowUserType>[] = [
    {
      field: "name",
      headerName: getLabel("OBJ_USER_TABLE_COL.userName"),
      align: "left",
    },
    {
      field: "email",
      headerName: getLabel("OBJ_USER_TABLE_COL.email"),
      align: "left",
    },
    {
      field: "phoneNumber",
      headerName: getLabel("OBJ_USER_TABLE_COL.phoneNumber"),
      align: "center",
    },
    {
      field: "createdAt",
      headerName: getLabel("OBJ_USER_TABLE_COL.createdAt"),
      align: "center",
      render: (cell: RowUserType) => {
        return (
          cell.createdAt && (
            <Box>
              {dayjs(cell.createdAt).format(AppConstant.FM_SHORT_DATE)}
              <br />
              {dayjs(cell.createdAt).format(AppConstant.FM_FULL_HOUR)}
            </Box>
          )
        );
      },
    },
    {
      field: "status",
      headerName: getLabel("OBJ_USER_TABLE_COL.status"),
      align: "center",
      render: (cell: RowUserType) => {
        return cell.state ? <StatusUser status={cell.state} /> : "";
      },
    },
    {
      field: "action",
      headerName: getLabel("OBJ_USER_TABLE_COL.action"),
      align: "center",
      render: (cell: RowUserType) => {
        return (
          <Stack direction="row" spacing={1} justifyContent="center">
            <IconButton onClick={cell.handleReset} title="Reset password">
              <RefreshOutlined />
            </IconButton>
          </Stack>
        );
      },
    },
  ];

  return {
    columnList,
  };
};

export default useUserColumn;
